import Loadable from "@/Loadable";

export default {
  // 个人中心
  ProfilePage: Loadable(() => import("@page/profile/ProfilePage")),
  // 首页
  HomePage: Loadable(() => import("@page/home/HomePage")),
  // 权限管理
  ModulePage: Loadable(() => import("@page/permission/module/ModulePage")),
  MenuPage: Loadable(() => import("@page/permission/menu/MenuPage")),
  RolePage: Loadable(() => import("@page/permission/role/RolePage")),
  UserPage: Loadable(() => import('@page/permission/user/UserPage')),
  DepartmentPage: Loadable(() => import('@page/permission/department/DepartmentPage')),
  // mrs-c调度
  SchedulePage: Loadable(() => import('@page/schedule/SchedulePage')),
  // 设备管理
  DevicePage: Loadable(() => import('@page/device/DevicePage')),
  // 直播流
  LiveStreamPage: Loadable(() => import('@page/liveStream/LiveStreamPage')),
  // frp反向代理服务器管理
  FrpServerPage: Loadable(() => import('@page/frpServer/FrpServerPage')),
  //流信息日志
  StreamInfoPage: Loadable(() => import('@page/log/streamInfo/StreamInfoPage')),
  //设备状态日志
  DeviceStatusPage: Loadable(() => import('@page/log/deviceStatus/DeviceStatusPage')),
  // 终端管理
  TerminalPage: Loadable(() => import('@page/terminal/TerminalPage')),
  // 直播管理
  LivePage: Loadable(() => import('@page/live/LivePage')),
  // 用户资源
  FlowPage: Loadable(() => import('@page/source/flow/FlowPage')),
  // 聚合服务器
  AggServerPage: Loadable(() => import('@page/aggServer/AggServerPage')),
  // 云导播
  // CasterPage: Loadable(() => import('@page/caster/CasterPage')),
  // 终端model管理
  ModelPage: Loadable(() => import('@page/model/ModelPage')),
  // 终端升级管理
  UpgradePage: Loadable(() => import('@page/upgrade/UpgradePage')),
  // 渠道管理
  ChannelDeptPage: Loadable(() => import('@page/channel/channelDept/ChannelDeptPage')),
  // 平台管理
  PlatformPage: Loadable(() => import('@page/channel/platform/PlatformPage')),

  // 设备管理列表
  DeviceManagePage: Loadable(() => import('@page/deviceManage/deviceList/DeviceManagePage')),
  // 设备管理基础信息
  DeviceBasicInfoPage: Loadable(() => import('@page/deviceManage/deviceBasicInfo/DeviceBasicInfoPage')),
  // 蓝牙设备
  BluetoothPage: Loadable(() => import('@page/deviceManage/bluetooth/BluetoothPage')),
  // 鼠标授权
  DeviceMouseAuthPage: Loadable(() => import('@page/deviceManage/deviceMouseAuth/DeviceMouseAuthPage')),

  // 用户管理
  UserManagePage: Loadable(() => import('@page/userManage/UserManagePage')),

  // 报警通知-报警日志
  PushLogManagePage: Loadable(() => import('@page/pushManage/pushLogManage/PushLogManagePage')),
  // 报警通知-报警推送
  PushManagePage: Loadable(() => import('@page/pushManage/pushManage/PushManagePage')),

  // 健康数据
  // 步数
  HealthStepPage: Loadable(() => import('@page/healthData/step/StepPage')),
  // 睡眠
  HealthSleepPage: Loadable(() => import('@page/healthData/sleep/SleepPage')),
  // 心率
  HealthHeartRatePage: Loadable(() => import('@page/healthData/heartRate/HeartRatePage')),
  // 血压
  HealthBloodPressurePage: Loadable(() => import('@page/healthData/bloodPressure/BloodPressurePage')),
  // 血氧
  HealthBloodOxygenPage: Loadable(() => import('@page/healthData/bloodOxygen/BloodOxygenPage')),
  // 压力
  HealthPressurePage: Loadable(() => import('@page/healthData/pressure/PressurePage')),
  // 温度
  HealthTemperaturePage: Loadable(() => import('@page/healthData/temperature/TemperaturePage')),
  // 血糖
  HealthBloodSugarPage: Loadable(() => import('@page/healthData/bloodSugar/BloodSugarPage')),
  // 位置
  HealthLocationPage: Loadable(() => import('@page/healthData/location/LocationPage')),

  // 数据统计
  // 设备使用统计
  StatisticsDeviceUsedPage: Loadable(() => import('@page/dataStatistics/deviceUsed/DeviceUsedPage')),
  // 数据大屏
  HealthyDataPage: Loadable(() => import('@page/dataStatistics/healthyData/HealthyDataPage')),

  // 电子围栏
  ElectricFencePage: Loadable(() => import('@page/electricFence/electricFence/ElectricFencePage')),

  // 工作台
  WorkbenchPage: Loadable(() => import('@page/workbench/WorkbenchPage')),

};
